<template>
	<div class="c-global-search-empty" v-if="headline">
		<ds-text
			html-element="h2"
			text-type="heading-lg"
			class="c-global-search-empty__headline"
		>
			{{ headline }}
		</ds-text>
		<ds-text class="c-global-search-empty__text" html-element="p" text-style="regular" text-type="body-sm">
			{{ text }}
		</ds-text>
	</div>
</template>

<script lang="ts" setup>
import {  DsText } from '@coloplast/design-system';

type Props = {
	headline: string;
	text: string;
};

defineProps<Props>();

</script>

<style lang="scss">
@import "multisite/styles/settings/settings";
@import "multisite/styles/tools/tools";

.c-global-search-empty {
	padding: 0;

	&__headline {
		margin: 0 0 ds-space(4);
	}

	&__text {
		color: ds-color("fg", "muted");
		margin: 0;
	}
}
</style>
